import { useQuery, useMutation, useQueryClient } from 'react-query';
import { adminAPI } from '../services/api';

export const useUsers = () => {
  return useQuery('admin-users', () => adminAPI.getUsers(), {
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export const useUpdateUser = () => {
  const queryClient = useQueryClient();
  
  return useMutation(
    ({ userId, updates }: { userId: number; updates: any }) => 
      adminAPI.updateUser(userId, updates),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('admin-users');
      },
    }
  );
};

export const useDeleteUser = () => {
  const queryClient = useQueryClient();
  
  return useMutation(
    (userId: number) => adminAPI.deleteUser(userId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('admin-users');
      },
    }
  );
};

export const useChangeUserPassword = () => {
  const queryClient = useQueryClient();
  
  return useMutation(
    ({ userId, newPassword }: { userId: number; newPassword: string }) => 
      adminAPI.changeUserPassword(userId, newPassword),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('admin-users');
      },
    }
  );
};
